(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/map-shared/map-utils.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/map-shared/map-utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


function getUniqueId() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'map';
  return "".concat(prefix, "-").concat(Date.now(), "-").concat(Math.floor(Math.random() * 10000));
}
function locationToArray(location) {
  const _ref = location !== null && location !== void 0 ? location : {},
    _ref$latitude = _ref.latitude,
    latitude = _ref$latitude === void 0 ? '' : _ref$latitude,
    _ref$longitude = _ref.longitude,
    longitude = _ref$longitude === void 0 ? '' : _ref$longitude;
  return [latitude.replace(',', '.'), longitude.replace(',', '.')];
}
function isPointInsideSweden(point, polygons) {
  const x = !isNaN(point[1]) ? parseFloat(point[1]) : point[1];
  const y = !isNaN(point[0]) ? parseFloat(point[0]) : point[0];
  for (const polygon of polygons) {
    const vs = polygon.map(_ref2 => {
      let _ref3 = _slicedToArray(_ref2, 2),
        lng = _ref3[0],
        lat = _ref3[1];
      return {
        x: lng,
        y: lat
      };
    });
    let inside = false;
    for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
      const xi = vs[i].x;
      const yi = vs[i].y;
      const xj = vs[j].x;
      const yj = vs[j].y;
      const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
      if (intersect) {
        inside = !inside;
      }
    }
    if (inside) {
      return true;
    }
  }
  return false;
}
function disableInteraction(map) {
  map.dragging.disable();
  map.touchZoom.disable();
  map.doubleClickZoom.disable();
  map.scrollWheelZoom.disable();
  map.boxZoom.disable();
  map.keyboard.disable();
  map.tap && map.tap.disable();
}
function enableInteraction(map) {
  map.dragging.enable();
  map.touchZoom.enable();
  map.doubleClickZoom.enable();
  map.scrollWheelZoom.enable();
  map.boxZoom.enable();
  map.keyboard.enable();
  map.tap && map.tap.enable();
}
function scrambleCoordinates(coordinate) {
  const coordinateStr = parseFloat(coordinate).toFixed(6);
  const integerPart = coordinateStr.split('.')[0];
  const decimalPart = coordinateStr.split('.')[1];
  const unchangedPart = decimalPart.substring(0, 3);
  const fourthDigit = parseInt(decimalPart[3], 10);
  const randomAdjustment = svsRandom.getRandomInt(-2, 2);
  let newFourthDigit = fourthDigit + randomAdjustment;
  newFourthDigit = Math.max(0, Math.min(9, newFourthDigit)).toString();
  const newLastDigits = svsRandom.getRandomInt(0, 99).toString().padStart(2, '0');
  const newDecimalPart = unchangedPart + newFourthDigit + newLastDigits;
  const scrambledCoordinate = parseFloat("".concat(integerPart, ".").concat(newDecimalPart));

  return scrambledCoordinate;
}
function calculateCumulativeSumDoubledUpToIndex(radiuses, endIndex) {
  let cumulativeSum = 0;
  const result = [];
  for (let i = 0; i <= endIndex && i < radiuses.length; i++) {
    cumulativeSum += radiuses[i] * 2;
    result.push(cumulativeSum);
  }
  return result;
}
function calculateSouthCoordinate(startCoord, distanceInMeters) {
  const R = 6371000;

  const lat1 = Math.PI / 180 * startCoord[0];

  const lat2 = lat1 - distanceInMeters / R;

  const newLat = 180 / Math.PI * lat2;

  const newLon = startCoord[1];
  return [newLat, newLon];
}
function generateCoordinateInSwe() {
  let latitude;
  let longitude;
  const sweBounds = svs.tur.lyckoplatsen.map.sweRectangleBounds;
  const swePath = svs.tur.lyckoplatsen.map.swe;
  do {
    latitude = Math.random() * (sweBounds[0][0] - sweBounds[1][0]) + sweBounds[1][0];
    longitude = Math.random() * (sweBounds[0][1] - sweBounds[1][1]) + sweBounds[1][1];
  } while (!isPointInsideSweden([latitude, longitude], swePath.features[0].geometry.coordinates));

  return [parseFloat(latitude.toFixed(6)), parseFloat(longitude.toFixed(6))];
}
function toRadians(degrees) {
  return degrees * (Math.PI / 180);
}
function calculateDistance(lat1, lng1, lat2, lng2) {
  const earthRadius = 6371; 
  const dLat = toRadians(lat2 - lat1);
  const dLng = toRadians(lng2 - lng1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = earthRadius * c;
  return distance;
}
function findClosestCoord(lat, lng, dataArray) {
  let closestCoord = null;
  let closestDistance = Infinity;
  dataArray.forEach(item => {
    const distance = calculateDistance(lat, lng, item.lat, item.lng);
    if (distance < closestDistance) {
      closestDistance = distance;
      closestCoord = {
        lat: item.lat,
        lng: item.lng,
        radius: item.radius
      };
    }
  });
  return closestCoord;
}
function getSouthCoordinate(coord, distance) {
  const distanceKm = distance / 1000;
  const earthRadius = 6371;
  const latRad = coord[0] * Math.PI / 180;
  const newLatRad = latRad - distanceKm / earthRadius;
  const newLat = newLatRad * 180 / Math.PI;
  return ["".concat(newLat), coord[1]];
}
function metresPerPixel(map) {
  const southEastPoint = map.getBounds().getSouthEast();
  const northEastPoint = map.getBounds().getNorthEast();
  const mapHeightInMetres = southEastPoint.distanceTo(northEastPoint);
  const mapHeightInPixels = map.getSize().y;
  return mapHeightInMetres / mapHeightInPixels;
}
function checkDuplicateWagersLocations(wagers) {
  const geoLocCount = new Map();
  const geoLocWagers = new Map();
  wagers.forEach(wager => {
    const geoLocKey = "".concat(wager.wager.bets[0].geoBoardData.geoLoc.latitude, ",").concat(wager.wager.bets[0].geoBoardData.geoLoc.longitude);

    geoLocCount.set(geoLocKey, (geoLocCount.get(geoLocKey) || 0) + 1);

    if (!geoLocWagers.has(geoLocKey)) {
      geoLocWagers.set(geoLocKey, wager);
    }
  });

  return Array.from(geoLocWagers.values()).map(wager => {
    const geoLocKey = "".concat(wager.wager.bets[0].geoBoardData.geoLoc.latitude, ",").concat(wager.wager.bets[0].geoBoardData.geoLoc.longitude);
    const count = geoLocCount.get(geoLocKey);
    return _objectSpread(_objectSpread({}, wager), {}, {
      wagerMultiplayed: count > 1 ? count : null
    });
  });
}

function getDistance(_ref4) {
  let from = _ref4.from,
    to = _ref4.to,
    _ref4$subMeter = _ref4.subMeter,
    subMeter = _ref4$subMeter === void 0 ? 0 : _ref4$subMeter;
  const lat1 = from[0];
  const lon1 = from[1];
  const lat2 = to[0];
  const lon2 = to[1];
  const R = 6371000;
  const diffLat = (lat2 - lat1) * (Math.PI / 180);
  const diffLon = (lon2 - lon1) * (Math.PI / 180);
  const a = Math.sin(diffLat / 2) * Math.sin(diffLat / 2) + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(diffLon / 2) * Math.sin(diffLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distanceInMeters = R * c - subMeter;
  if (distanceInMeters > 10000) {
    return "".concat((distanceInMeters / 1000).toFixed(1), " km");
  }
  return "".concat(distanceInMeters.toFixed(0), " m");
}


function getFlyToDuration(map, targetLatLng, targetZoom) {
  const from = map.getCenter();
  const to = leaflet.latLng(targetLatLng);
  const size = map.getSize();
  const startZoom = map._animateToZoom || map.getZoom();
  const w0 = Math.max(size.x, size.y);
  const w1 = w0 * map.getZoomScale(startZoom, targetZoom);
  const u1 = to.distanceTo(from) || 1;
  const rho = 1.42;
  const rho2 = rho * rho;
  function r(i) {
    const s1 = i ? -1 : 1;
    const s2 = (w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1) / (2 * (i ? w1 : w0) * rho2 * u1);
    return Math.log(Math.sqrt(s2 * s2 + 1) - s2);
  }
  const S = (r(1) - r(0)) / rho;
  return S / 17;
}
Object.assign(svs.tur.lyckoplatsen.map, {
  getUniqueId,
  locationToArray,
  isPointInsideSweden,
  disableInteraction,
  enableInteraction,
  scrambleCoordinates,
  calculateCumulativeSumDoubledUpToIndex,
  calculateSouthCoordinate,
  generateCoordinateInSwe,
  toRadians,
  calculateDistance,
  findClosestCoord,
  getSouthCoordinate,
  metresPerPixel,
  checkDuplicateWagersLocations,
  getDistance,
  getFlyToDuration
});

 })(window);